<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Add report credits</template>

    <Sheet.Body class="pt-[15px]">
      <BuyReportCreditsBody
        v-model="selectedProductId"
        :loading="loading"
        :products="products"
      />
    </Sheet.Body>

    <div class="shrink-0 px-4 pt-2 pb-[calc(env(safe-area-inset-bottom)+16px)]">
      <Button
        variant="primary"
        size="lg"
        class="w-full"
        :disabled="!selectedProduct"
        @click="handleContinue"
      >
        Continue
      </Button>
    </div>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Button, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'

import BuyReportCreditsBody from './BuyReportCreditsBody.vue'
import { useBuyReportCredits } from '../useBuyReportCredits'

const props = defineProps<{ afterPurchase?: () => void }>()

const { close } = useSheet()
const {
  loading,
  products,
  selectedProductId,
  selectedProduct,
  handleContinue,
} = useBuyReportCredits(props.afterPurchase)
</script>
